$(document).on('ready turbolinks:load', () => {
  $(".registration .field__radio__check").on('change', (e) => {
    $(e.target).closest('.field__radio').find('.field__radio--checked').removeClass('field__radio--checked')
    $(e.target).parent().addClass('field__radio--checked')
  });
})
